@let product = this.product();

<div class="min-w-[221px] h-full flex flex-col">
  <div>
    @if (product.images[0]) {
      <img
        [src]="product.images[0]"
        [alt]="'membership.plan.' + (product.name | lowercase) | transloco"
        width="86px"
        height="83px"
        class="w-[86px] h-[83px] object-cover mb-2"
      />
    }

    <p class="font-semibold">{{ 'membership.plan.' + (product.name | lowercase) | transloco }}</p>
    <p class="font-semibold text-2xl my-5 flex flex-col gap-y-1">
      @if (product.metadata['checkout'] !== 'false') {
        {{
          product.defaultPrice.unitAmount / 100
            | currency: (product.defaultPrice.currency | uppercase) : 'symbol' : '1.0-0'
        }}
        /
        {{ 'common.year' | transloco }}

        <span class="text-sm">
          {{ product.metadata['number_of_searches'] }} {{ 'common.number-of-searches' | transloco }}</span
        >
      } @else {
        {{ 'common.custom' | transloco }}
      }
    </p>
    <p class="text-xs">{{ 'membership.plans.description.title' | transloco }}</p>

    @if (descriptionItems().length) {
      <ul class="mt-5 flex flex-col gap-y-2">
        @for (item of descriptionItems(); track $index) {
          <li class="flex gap-x-2">
            <ui-kit-checkbox-circle-fill />
            <p class="text-xs">{{ item }}</p>
          </li>
        }
      </ul>
    }
  </div>

  <div class="mt-auto">
    @if (product.metadata['number_of_included_cyber_report'] === '0') {
      <div class="mt-10">
        <hr />
        <div class="flex justify-between items-center mt-3">
          <p class="uppercase text-[#6A7282] font-bold text-xs">Add On</p>
          <ui-kit-badge [type]="'primary'" [additionalClasses]="'rounded-lg font-normal opacity-80'" [size]="'xs'">
            25% Off Quartely
          </ui-kit-badge>
        </div>
        <p class="text-[#101828] font-semibold text-xs mt-2">Cyber exposure report</p>
        <p class="text-[#4A5565] text-xs mt-1">Is your organisation's data being traded on the dark web?</p>

        <div class="mt-3 flex flex-col gap-2">
          <div
            (click)="selectCyberExposureProduct(null)"
            (keydown.enter)="selectCyberExposureProduct(null)"
            (keydown.space)="selectCyberExposureProduct(null)"
            [class]="
              selectedCyberExposureProductId() === null
                ? 'border border-[#5B9BAD] bg-[#5B9BAD0D]'
                : 'border border-[#E5E7EB] bg-white'
            "
            class="rounded-md p-2 text-[#364153] font-medium text-xs cursor-pointer flex items-center gap-2"
            tabindex="0"
            role="radio"
            [attr.aria-checked]="selectedCyberExposureProductId() === null"
          >
            <div
              class="flex items-center justify-center w-4 h-4 rounded-full border-2 flex-shrink-0"
              [class.border-[#5B9BAD]]="selectedCyberExposureProductId() === null"
              [class.border-[#D1D5DB]]="selectedCyberExposureProductId() !== null"
            >
              @if (selectedCyberExposureProductId() === null) {
                <div class="w-2 h-2 rounded-full bg-[#5B9BAD]"></div>
              }
            </div>
            No thanks
          </div>

          @for (cyberExposureProduct of cyberExposureProducts(); track cyberExposureProduct.id) {
            <div
              (click)="selectCyberExposureProduct(cyberExposureProduct)"
              (keydown.enter)="selectCyberExposureProduct(cyberExposureProduct)"
              (keydown.space)="selectCyberExposureProduct(cyberExposureProduct)"
              [class]="
                selectedCyberExposureProductId() === cyberExposureProduct.id
                  ? 'border border-[#5B9BAD] bg-[#5B9BAD0D]'
                  : 'border border-[#E5E7EB] bg-white'
              "
              class="rounded-md p-2 text-[#364153] font-medium text-xs cursor-pointer flex justify-between items-center"
              tabindex="0"
              role="radio"
              [attr.aria-checked]="selectedCyberExposureProductId() === cyberExposureProduct.id"
            >
              <div class="flex items-center gap-2">
                <div
                  class="flex items-center justify-center w-4 h-4 rounded-full border-2 flex-shrink-0"
                  [class.border-[#5B9BAD]]="selectedCyberExposureProductId() === cyberExposureProduct.id"
                  [class.border-[#D1D5DB]]="selectedCyberExposureProductId() !== cyberExposureProduct.id"
                >
                  @if (selectedCyberExposureProductId() === cyberExposureProduct.id) {
                    <div class="w-2 h-2 rounded-full bg-[#5B9BAD]"></div>
                  }
                </div>
                {{ cyberExposureProduct.name }}
              </div>

              <p class="font-bold text-xs text-[#101828]">
                {{
                  cyberExposureProduct.defaultPrice.unitAmount / 100
                    | currency: (cyberExposureProduct.defaultPrice.currency | uppercase) : 'symbol' : '1.0-0'
                }}
              </p>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="bg-[#F7FAFB] border border-[#0D6373] p-2 rounded-lg">
        <div class="flex justify-between items-center">
          <p class="uppercase text-[#6A7282] font-bold text-xs">Add On</p>
          <ui-kit-badge [type]="'primary'" [additionalClasses]="'rounded-lg font-normal opacity-80'" [size]="'xs'">
            x{{ product.metadata['number_of_included_cyber_report'] }} Included
          </ui-kit-badge>
        </div>
        <p class="text-[#101828] font-semibold text-xs mt-2">Cyber exposure report</p>
        <p class="text-[#4A5565] text-xs mt-1">Is your organisation's data being traded on the dark web?</p>
      </div>
    }

    @if (product.metadata['checkout'] !== 'false') {
      <button ui-kit-button class="mt-[52px] w-full" (click)="createSubscription()">
        {{ 'membership.plans.cta' | transloco }}
      </button>
    } @else {
      <a ui-kit-button class="mt-[52px] w-full" [href]="'mailto:' + enterprisePlanEmail">
        {{ 'membership.plans.no-checkout.cta' | transloco }}
      </a>
    }
  </div>
</div>
